/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Step2_BodyInputs */

const cs_sreality_step2_body = /** @type {(inputs: Sreality_Step2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Při založení makléře systém zavolá addSeller s jeho Seznam loginem a GSM. To je jeho veřejná identita na Sreality, ne druhý importní účet. Při prvním přihlášení na portál může ještě odsouhlasit podmínky.`)
};

const en_sreality_step2_body = /** @type {(inputs: Sreality_Step2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you create a broker, the system calls addSeller with their Seznam login and GSM. That is their public Sreality identity, not a second import account. They may still need to accept Sreality terms on first portal login.`)
};

/**
* | output |
* | --- |
* | "When you create a broker, the system calls addSeller with their Seznam login and GSM. That is their public Sreality identity, not a second import account. Th..." |
*
* @param {Sreality_Step2_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_step2_body = /** @type {((inputs?: Sreality_Step2_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Step2_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_step2_body(inputs)
	return cs_sreality_step2_body(inputs)
});